import {find, findIn} from '@elements/dom-utils';
import {onFind, findAllIn} from "@elements/init-modules-in-scope";

const defaultSelectors = {
    checkbox: '.js-accordion__checkbox-input',
    button: '.js-accordion-button',
    stickybar: '.js-additional-services-overview__sticky-bar',
};

export function init(selectors = defaultSelectors) {
    let checkboxes = [];
    let buttons = [];
    let stickybarContent;
    let counter = 0;

    onFind(selectors.button, function (button) {
        buttons.push(button);
    })

    onFind(selectors.stickybar, function (stickybar) {
        stickybarContent = findIn('.sticky-bar__title', stickybar);
        stickybarContent.innerHTML = '<span class="counter">' + counter + ' ' + '</span>' + stickybarContent.innerHTML;
    })

    onFind(selectors.checkbox, function (checkbox) {
        checkboxes.push(checkbox);

        checkbox.addEventListener("change", function (event) {
            updateCheckbox(event.currentTarget);
        })
    })

    function updateCheckbox(target) {
        let isChecked = false;

        for (let i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].id === target.id) {
                checkboxes[i].checked = target.checked;
                target.checked ? isChecked = true : isChecked = false;
            }
        }

        isChecked ? counter++ : counter--;
        stickybarContent.getElementsByClassName('counter')[0].innerHTML = counter + ' ';
    }
}